import React, {Component} from 'react';
import styled from 'styled-components';
import ErrorListItem from './components/ErrorListItem';
import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';
import {connect} from 'react-redux';
import CarErrorsActions from '../../redux/CarErrorsRedux';
import ClientActions from '../../redux/ClientRedux';
import {removeEmpty} from '../../helpers/object';
import InfiniteScroll from 'react-infinite-scroller';
import Spinner from '@atlaskit/spinner';
import {Trans} from 'react-i18next';

const ListContentWrapper = styled.div`
  margin: 24px 0px;
`;


class ErrorsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: {},
      currentPage: 1,
      hasMore: false,
    };
  }

  componentDidMount() {
    this.loadData();
    
    if (!this.props.client) {
      this.props.getClient(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching
      && this.props.dataTotalPages > this.state.currentPage) {
        this.setState({hasMore: true});
    }
  }

  onFilter = (fieldName, value) => {
    this.setState({
      filters: {...this.state.filters, [fieldName]: value},
      currentPage: 1,
      hasMore: false,
    }, () => this.loadData());
  }

  loadData() {
    const carId = this.props.match.params.carId;
    const {currentPage} = this.state;
    const {query, ...filters} = this.state.filters;
    const filter = removeEmpty({...filters});

    this.props.getData(
      carId,
      removeEmpty({
        page: currentPage,
        query,
        filter: Object.keys(filter).length > 0 ? filter : undefined,
    }));
  }

  onLoadMore = () => {
    const currentPage = this.state.currentPage + 1;
    if (currentPage <= this.props.dataTotalPages) {
      this.setState({currentPage, hasMore: false}, () => this.loadData());
    }
  }

  render() {
    const {
      data,
      fetching,
      permissions,
    } = this.props;

    if (!permissions) {
      return null;
    }

    return (
      <ContentWrapper>
        <PageTitle><Trans>Errors archive</Trans></PageTitle>
        <ListContentWrapper>
        {data && data.length && data.length > 0 ? (
          <InfiniteScroll
            pageStart={0}
            loadMore={this.onLoadMore}
            hasMore={this.state.hasMore}
            loader={<Spinner />}
            initialLoad={false}
            threshold={200}
          >
            {data.map(error => (
              <ErrorListItem
                key={`error_list_item_${error.code + error.createdAt}`}
                {...error}
              />
            ))}
          </InfiniteScroll>
          ) : (
            fetching ? <Spinner /> : <div><Trans>No Data</Trans></div>
          )
        }
        </ListContentWrapper>
      </ContentWrapper>
    );
  }
}


const mapStateToProps = state => {
  return {
    permissions: 
      state.userProfile.permissions.client && 
      state.userProfile.permissions.client.car && 
      state.userProfile.permissions.client.car.errors && 
      state.userProfile.permissions.client.car.errors.archive,
    data: state.carErrors.data,
    dataTotalPages: state.carErrors.totalPages,
    fetching: state.carErrors.fetching,
    error: state.carErrors.error,
    client: state.client.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClient: id => dispatch(ClientActions.clientRequest(id)),
    getData: (id, params) => dispatch(CarErrorsActions.carErrorsArchiveRequest(id, params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorsPage);